import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import MapContainer from "./container/MapContainer";
import { useAllContexts } from "../../hooks/useAllContexts";
import { getTokens } from "../../services/services";
import { useAuth } from "../../hooks/UserAuthProvider";
import ViewModal from "./container/ViewModal";

const Map = () => {
  const { search } = useLocation();
  const typeIdFromURL = new URLSearchParams(search).get("typeId");
  const history = useHistory();

  const loginCode = new URLSearchParams(search).get("code");
  const recoverPassword = new URLSearchParams(search).get("recover_password");
  const updatePassword = new URLSearchParams(search).get("update_password");

  const { saveTokens, saveUser, isAuthenticated, tokens } = useAuth();

  const { ameaData, environment, meteo, allSensors } = useAllContexts();

  const [refreshData, setRefreshData] = useState(false);
  const [visibleData, setVisibleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewRouteForm, setShowNewRouteForm] = useState(false);
  const [mapSelectedCategory, setMapSelectedCategory] = useState("infra");
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const refresh = () => setRefreshData((prev) => !prev);

  const handleLoading = () => {
    const loadingStates = {
      5: meteo.loading,
      31: allSensors.loading,
      122: ameaData.loading,
    };
    setLoading(loadingStates[typeIdFromURL] || false);
  };

  useEffect(() => {
    handleLoading();
  }, [
    typeIdFromURL,
    mapSelectedCategory,
    meteo.loading,
    allSensors.loading,
    ameaData.loading,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      saveUser(tokens.accessToken);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const fetchTokens = async () => {
      await getTokens(loginCode).then((response) => {
        if (response) {
          saveTokens(response);
          history.replace("map?typeId=122");
          // saveUser(response.access_token);
        }
      });
    };
    if (loginCode) {
      fetchTokens();
    }
    if (recoverPassword) {
      setShowRecoverModal(true);
    }

    if (updatePassword) {
      setShowUpdateModal(true);
    }
  }, [loginCode, recoverPassword, updatePassword]);

  const getVisibleData = useMemo(() => {
    const dataMap = {
      5: meteo.meteoInfoData,
      31: allSensors?.allSensorsData?.[31]?.data ?? [],
      122:
        mapSelectedCategory === "infra"
          ? ameaData.get?.infrastructures?.filteredData.length === 0
            ? ameaData.get?.infrastructures?.data
            : ameaData.get?.infrastructures?.filteredData
          : ameaData.get?.routes,
    };
    return dataMap[typeIdFromURL] || [];
  }, [
    typeIdFromURL,
    mapSelectedCategory,
    showNewRouteForm,
    meteo.meteoInfoData,
    allSensors.allSensorsData,
    ameaData.get,
  ]);

  useEffect(() => {
    setVisibleData(getVisibleData);
  }, [getVisibleData, refreshData]);

  return (
    <>
      <MapContainer
        data={visibleData}
        loading={loading}
        categoryId={typeIdFromURL}
        selectedCategory={{
          get: mapSelectedCategory,
          set: setMapSelectedCategory,
        }}
        showNewRouteForm={{ get: showNewRouteForm, set: setShowNewRouteForm }}
        refresh={refresh}
      />
      <ViewModal
        modalStatus={showRecoverModal || showUpdateModal}
        title="Ανάκτηση Κωδικού Πρόσβασης"
        closeModal={() => {
          setShowRecoverModal(false);
          setShowUpdateModal(false);
        }}
      >
        {showRecoverModal && (
          <p>
            Η διαδικασία ανάκτησης του κωδικού πρόσβασης μπορεί να ολοκληρωθεί
            ακολουθώντας τον σύνδεσμο που έχει αποσταλεί στη διεύθυνση email
            σας.
          </p>
        )}
        {showUpdateModal && (
          <p>
            Η διαδικασία ανάκτησης του κωδικού πρόσβασης ολοκληρώθηκε. Ο κωδικός
            πρόσβασης έχει ανανεωθεί.
          </p>
        )}
      </ViewModal>
    </>
  );
};

export default Map;
